import React from 'react';
import { Divider } from 'antd'
import { QueryQuestionCount } from '../../../online'
import * as local_urls from '../../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;
import QuestionCategoryRadioSelect from '../../bankQuestion/questionCategorySelect/questionCategoryRadioSelect';

export const dynamicWizTableColumns = (self, score) => [
  {
    title: '题目分类',
    dataIndex: 'questionCategoryTitle',
    key: 'questionCategoryTitle',
    width: 200
  },
  {
    title: '题型',
    dataIndex: 'typeTitle',
    key: 'typeTitle',
    width: 100
  },
  {
    title: '难度',
    dataIndex: 'difficultyTitle',
    key: 'difficultyTitle',
    width: 80
  },
  {
    title: '题目数量',
    dataIndex: 'size',
    key: 'size',
    width: 80
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 80,
    render: (text, record) => (
      <span>
        <a onClick={e => self.editRow(record)}> 编辑</a>
        <Divider type='vertical' />
        <a onClick={e => self.deleteDynamicRow(record)}>删除</a>
      </span>
    ),
  },
];

export const dynamicWizModalFormColumns = (self, data) => {
  let questionCategory
  if (data['questionCategory']) {
    questionCategory = data['questionCategory']
  } else {
    questionCategory = []
  }

  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "题目分类",
      name: "questionCategory",
      dataIndex: "questionCategory",
      tableItem: {},
      formItem: {
        type: 'diy',
        selects: questionCategory,
        categoryType: '2',
        mode: 1,
        checkable: false,
        diy: QuestionCategoryRadioSelect,
        rules: [
          {
            required: true,
            message: '请选择题目分类',
          }
        ],
      }
    },
    {
      title: "题型",
      name: "type",
      dataIndex: "type",
      dict: [
        { code: 0, codeName: "单选题" },
        { code: 1, codeName: "多选题" },
        { code: 2, codeName: "判断题" },
      ],
      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: '请选择符合题型',
          }
        ],
        allowClear: true
      }
    },
    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      dict: [
        { code: 0, codeName: "低" },
        { code: 1, codeName: "中" },
        { code: 2, codeName: "高" }
      ],
      searchItem: {},
      formItem: {
        type: "select",
        rules: [
          {
            required: true,
            message: '请选择难度',
          }
        ],
        allowClear: true
      }
    },
    {
      title: '',
      name: 'links',
      formItem: {
        type: 'diy',
        links: ['questionCategory', 'type', 'difficulty'],
        diy: ({
          linksValues
        }) => {
          const { questionCategory, type, difficulty, order } = linksValues
          return <QueryQuestionCount questionCategory={questionCategory} type={type} mode={1}
            changeCount={(value) => self.size = value} difficulty={difficulty} />
        }
      }
    },
  ]
};


